module.exports = __webpack_public_path__ + "static/media/28.e64dea1c.jpg";